import { kuferClient } from '@xver/libs/axios';

import {
    CreateVolumeRequest,
    CreateVolumeResponse,
    ListVolumesResponse,
    ResizeVolumeRequest,
    VolumeResponse,
} from './model';

const ENDPOINTS = {
    LIST: (containerId: string) => `/v1/containers/${containerId}/volumes`,
    CREATE: (containerId: string) => `/v1/containers/${containerId}/volumes`,
    GET: (containerId: string, volumeId: string) =>
        `/v1/containers/${containerId}/volumes/${volumeId}`,
    RESIZE: (containerId: string, volumeId: string) =>
        `/v1/containers/${containerId}/volumes/${volumeId}`,
    DELETE: (containerId: string, volumeId: string) =>
        `/v1/containers/${containerId}/volumes/${volumeId}`,
};

export function listVolumes(containerId: string): Promise<ListVolumesResponse> {
    return kuferClient.get(ENDPOINTS.LIST(containerId));
}

export function getVolume(containerId: string, volumeId: string): Promise<VolumeResponse> {
    return kuferClient.get(ENDPOINTS.GET(containerId, volumeId));
}

export function createVolume(
    containerId: string,
    data: CreateVolumeRequest
): Promise<CreateVolumeResponse> {
    return kuferClient.post(ENDPOINTS.CREATE(containerId), data);
}

export function resizeVolume(
    containerId: string,
    volumeId: string,
    data: ResizeVolumeRequest
): Promise<VolumeResponse> {
    return kuferClient.patch(ENDPOINTS.RESIZE(containerId, volumeId), data);
}

/** Responds 204 with no body. */
export function deleteVolume(containerId: string, volumeId: string): Promise<void> {
    return kuferClient.delete(ENDPOINTS.DELETE(containerId, volumeId));
}
